import type { Transition, Variants } from "motion/react";

/** The house spring: quick, a touch of overshoot. Used for presses, chips, sliding indicators and cards settling. */
export const spring: Transition = { type: "spring", stiffness: 520, damping: 34, mass: 0.8 };

/** A softer spring for larger surfaces: sheets, panes, cards entering. */
export const softSpring: Transition = { type: "spring", stiffness: 300, damping: 30 };

/** A loose, playful spring for the mark and empty-state moments. */
export const bouncy: Transition = { type: "spring", stiffness: 260, damping: 12 };

export const ease = [0.22, 1, 0.36, 1] as const;

/** Fade and rise, for a list item or a block entering. Pair with `staggerParent` on the container. */
export const rise: Variants = {
  hidden: { opacity: 0, y: 14, scale: 0.98 },
  show: { opacity: 1, y: 0, scale: 1, transition: softSpring },
};

/** Container variants that stagger their children's `rise`. */
export const staggerParent = (gap = 0.04, delay = 0): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: gap, delayChildren: delay } },
});

